import { createFileRoute } from '@tanstack/react-router'
import { UsersPage } from '../../../features/admin/UsersPage'

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/admin/users')({
  component: AdminUsersRoute,
})

/* ───── Route Component ───── */

function AdminUsersRoute() {
  return <UsersPage />
}
